module.exports = "/images/vendor/flag-icon-css/flags/1x1/li.svg?748d1f9967c0c449deca7eeb7429ae11";